<script setup lang="ts">
/** Resignation Letter (Director) — 사임 이사 1인당 1부(상위 DocScope 스코프). 원본 재현. */
import CddVarField from '@/features/startTask/my_preset/sg/aura/agm/cdd/CddVarField.vue';
import '@/features/startTask/my_preset/sg/aura/agm/docs/agmDoc.css';
</script>

<template>
  <div class="agm-doc">
    <p class="doc-p"><CddVarField field-key="director_name" label="Director name" /><br />
      <CddVarField field-key="director_address" label="Director address" /></p>
    <p class="doc-p">Date: <CddVarField field-key="resignation_date" label="Resignation date" /></p>

    <p class="doc-p" style="margin-top:10px">The Board of Directors<br />
      <CddVarField field-key="company_name" label="Company Name" /><br />
      <CddVarField field-key="company_address" label="Company address" /></p>

    <p class="doc-p">Dear Sir/Madam</p>
    <p class="sec-title">RESIGNATION FROM OFFICE</p>
    <p class="doc-p">I write to inform you that I am resigning from the office as a Director of the Company with effect from the date of this letter.</p>
    <p class="doc-p">Yours faithfully</p>

    <div class="sign-block" style="margin-top:14px">
      <div class="sign-line-txt">________________________</div>
      <div class="sign-nm"><CddVarField field-key="director_name" label="Director name" /></div>
    </div>
  </div>
</template>

<style scoped>
.sign-nm { font-weight: 700; }
.sign-line-txt { color: #94a3b8; letter-spacing: 1px; margin: 2px 0; }
</style>
